import GeneratedShareLinkStore from "./generated/GeneratedShareLinkStore"

class ShareLinkStore extends GeneratedShareLinkStore {

}

export const shareLinkStore = new ShareLinkStore()
